import { api } from '../../../services/api';

export interface IntercompanyBalance {
  /** Devedora — quem paga a transferência. */
  fromCompanyId: string;
  fromCompanyName: string;
  /** Credora — quem recebe. */
  toCompanyId: string;
  toCompanyName: string;
  /** Sempre > 0: a direção já está expressa em from/to. */
  amountCents: number;
  chargeIds: string[];
}

export interface IntercompanySettlement {
  id: string;
  fromCompanyId: string;
  fromCompanyName: string;
  toCompanyId: string;
  toCompanyName: string;
  amountCents: number;
  chargeCount: number;
}

export interface SettlePayload {
  fromCompanyId: string;
  toCompanyId: string;
  year: number;
  month: number;
  fromBankAccountId: string;
  toBankAccountId: string;
  /** Omitido = último dia da competência. */
  settlementDate?: string;
}

export const intercompanyService = {
  getBalance: (year: number, month: number): Promise<{ data: IntercompanyBalance[] }> =>
    api.get('/financial/intercompany/balance', { params: { year, month } }).then((r) => r.data),

  listSettlements: (year: number, month: number): Promise<{ data: IntercompanySettlement[] }> =>
    api.get('/financial/intercompany/settlements', { params: { year, month } }).then((r) => r.data),

  settle: (payload: SettlePayload): Promise<{ data: { id: string | null; amountCents: number } }> =>
    api.post('/financial/intercompany/settle', payload).then((r) => r.data),

  reverse: (settlementId: string) =>
    api.delete(`/financial/intercompany/settlements/${settlementId}`).then((r) => r.data),
};
